// extracted by mini-css-extract-plugin
export default {"wrapperInputNumber":"TableDataComponent_wrapperInputNumber__ZpgWl"};